import type { QBusEventMap } from "@otto-ec/global-resources";

export type HistoricEventData = { historic: boolean } | undefined;

export enum SQRL_EVENT {
  SEARCH_CLOSE = "squirrel.search.close",
  SEARCH_OPEN = "squirrel.search.open",
  SEARCH_HIDE = "squirrel.search.hide",
  SEARCH_FOCUS = "squirrel.search.focus"
}

type FTFindHistoricEvent = {
  topic: SQRL_EVENT;
  data: HistoricEventData;
};

type FTFindHistoricMergeEvent = FTFindHistoricEvent & {
  topic: SQRL_EVENT.SEARCH_CLOSE;
};

type FTFindHistoricPushEvent = FTFindHistoricEvent & {
  topic: SQRL_EVENT.SEARCH_OPEN;
};

export enum FTFIND_EVENT {
  MERGE = "ftfind.history.merge",
  PUSH = "ftfind.history.push",
  SHIFT = "ftfind.history.shift"
}

export type FTFindEvents = QBusEventMap<{
  [FTFIND_EVENT.MERGE]: [FTFindHistoricMergeEvent];
  [FTFIND_EVENT.PUSH]: [FTFindHistoricPushEvent];
  [FTFIND_EVENT.SHIFT]: [];
}>;
